import { createRoot } from "react-dom/client";
import React from "react";
import App from "./App.tsx";
import "./index.css";
import { I18nProvider } from "@/contexts/i18nContext";
import GlobalErrorBoundary from "./components/common/GlobalErrorBoundary.tsx";
import { BrowserRouter } from "react-router-dom";
import { initializeAuth } from "./authInitializer.ts";

initializeAuth();

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <GlobalErrorBoundary>
          <App />
        </GlobalErrorBoundary>
      </BrowserRouter>
    </I18nProvider>
  </React.StrictMode>,
);
